/* eslint-disable @typescript-eslint/no-unused-vars */
import {buildHandleEnterKeyPress} from '../utils/accessibility';

export interface BaseButtonProps {
  children: React.ReactNode;
  disabled?: boolean;
  href?: string;
  inverse?: boolean;
  onClick?: () => void;
  className: string;
  id?: string;
}

export const Button = ({
  children,
  disabled = false,
  href,
  inverse = false,
  onClick = () => {},
  className,
  id,
}: BaseButtonProps) => {
  const childrenComponents = typeof children === 'string' ? <span className="button-text">{children}</span> : children;

  const onClickHandler = () => {
    if (!disabled) {
      onClick();
    }
  };
  // Todo: utilize the href prop to perform link actions because we're using <button> instead of <a>
  return (
    <button
      className={className}
      id={id}
      data-cy={`button-${disabled ? 'disabled' : 'enabled'}`}
      disabled={disabled}
      // href={href} // NOTE: not a valid prop for <button>, not sure if even being used atm
      onClick={onClickHandler}
      onKeyPress={buildHandleEnterKeyPress(onClickHandler)}
      tabIndex={0}>
      {childrenComponents}
    </button>
  );
};
